export default {
  // Login
  login: {
    lang: 'Sprache',
    systemname: 'Login',
    username: 'Benutzername',
    username_label: 'Bitte Benutzername eingeben',
    pwd: 'Passwort',
    pwd_label: 'Bitte Passwort eingeben',
    pwd_info: 'Bitte korrektes Passwortformat eingeben',
    success_msg: 'Erfolgreich angemeldet',
    error_name: 'Falsches Passwort',
    error_res: 'Anmeldeanforderungen nicht erfüllt',
    login: 'Anmelden',
  },
  // Sidebar
  aside: {
    systemname: 'Konsole',
    quit: 'Abmelden',
    deviceControl: 'Steuerung',
    basicSetting: 'Einstellungen',
    workerSetting: 'Personen',
    deviceMonitoring: 'Überwachung',
    recordManagement: 'Aufzeichnungen',
    securityManagement: 'Schlüsselverwaltung',
    tips: 'Hinweis',
    tips_msg: 'Möchten Sie sich abmelden?',
  },
  control: {
    remoteControl: 'Fern',
    restart: 'Neustart',
    clickToRestart: 'Zum Neustart klicken',
    restartConfirm: 'Neustart bestätigen?',
    restartSuccess: 'Neustart erfolgreich',
    restartFailed: 'Neustart fehlgeschlagen',
    remoteOpen: 'Tür fernöffnen',
    clickToOpen: 'Zum Öffnen klicken',
    openConfirm: 'Fernöffnung bestätigen?',
    remoteOpenSuccess: 'Öffnen erfolgreich',
    remoteOpenFailed: 'Öffnen fehlgeschlagen',
    reset: 'Gerät zurücksetzen',
    clickToReset: 'Zum Zurücksetzen klicken',
    resetConfirm: 'Zurücksetzen bestätigen?',
    resetSuccess: 'Zurücksetzen erfolgreich',
    resetFailed: 'Zurücksetzen fehlgeschlagen',
    firmwareUpgrade: 'Firmware-Update',
    upgradeConfig: 'Update-Konfiguration',
    firmwareUrl: 'Firmware-URL',
    md5Checksum: 'md5-Wert',
    startUpgrade: 'Update starten',
    urlRequired: 'URL ist erforderlich',
    md5Required: 'md5 ist erforderlich',
    urlInvalid: 'Bitte gültige URL eingeben',
    md5Invalid: 'Bitte gültiges md5 eingeben',
    upgradeConfirm: 'Update bestätigen?',
    upgradeSuccess: 'Update erfolgreich',
    clearFile: "Datei löschen",
    uploading: 'Hochladen...',
    uploadAndUpgrade: 'Hochladen & Aktualisieren',
    restartTips: 'Sicherer Neustart, keine Daten gehen verloren',
    restarting: 'Neustart...',
    remoteTips: 'Fernsteuerung der Zugangstür',
    opening: 'Öffnet...',
    resetTips: 'Werksreset, löscht alle Daten',
    reseting: 'Setzt zurück...',
    urlUpgrade: 'Update per URL',
    fileUpgrade: 'Update per Datei',
    uploadFile: 'Firmware-Datei hochladen',
    formatFile: 'Unterstützt .zip oder .dpk, max 20MB',
    fileName: 'Dateiname',
    size: 'Größe',
  },
  config: {
    second: 's',
    millisecond: 'ms',
    min: 'Minuten',
    notsave: 'Nicht speichern',
    save: 'Speichern',
    noVoice: 'Keine Stimme',
    no: 'Nein',
    yes: 'Ja',
    basicConfiguration: 'Grundkonfiguration',
    displaySettings: 'Anzeige',
    informationDisplay: 'Infoanzeige',
    audioSettings: 'Audio',
    languageAndThemes: 'Sprache & Thema',
    autoAdjustScreenBrightness: 'Auto-Helligkeit',
    screenBrightness: 'Bildschirmhelligkeit',
    autoTurnOffScreen: 'Auto-Bildschirm aus',
    autoTurnOffScreenTime: 'Zeit bis Ausschalten',
    autoScreenSaver: 'Auto-Bildschirmschoner',
    autoScreenSaverTime: 'Zeit Bildschirmschoner',
    displayDeviceSn: 'SN anzeigen',
    displayIp: 'IP anzeigen',
    displayIdentityCard: 'Cloud-Zertifikat anzeigen',
    volume: 'Lautstärke',
    language: 'Sprache',
    displayCode: "Mini-App-Code anzeigen",
    themeMode: "Thema",
    cn: 'Chinesisch',
    en: 'Englisch',
    es: 'Spanisch',
    fr: 'Französisch',
    de: 'Deutsch',
    ru: 'Russisch',
    ar: 'Arabisch',
    pt: 'Port.',
    ko: 'Koreanisch',
    standardMode: 'Standardmodus',
    simpleMode: 'Einfacher Modus',
    firstLogin: 'Erste Anmeldung',
    backlight: 'Hintergrundlicht',
    brightness: 'Weißlicht',
    nirBrightness: 'IR-Licht',
    never: 'Nie',
    min1: '1 Minute',
    min2: '2 Minuten',
    min3: '3 Minuten',
    min4: '4 Minuten',
    min5: '5 Minuten',
    networkConfiguration: 'Netzwerk',
    otherConfiguration: 'Andere',
    ipConfiguration: 'IP-Konfiguration',
    devicePassword: 'Gerätepasswort',
    protocolPassword: 'Protokollpasswort',
    networkType: 'Netzwerktyp',
    ethernet: 'Ethernet',
    wifiName: 'Wi‑Fi',
    wifiPassword: 'Wi‑Fi-Passwort',
    dhcpModeSelection: 'DHCP-Modus',
    dhcpMode: 'Automatisch',
    customNetworkConfiguration: 'Manuell',
    ipAddress: 'IP-Adresse',
    gateway: 'Gateway',
    subnetMask: 'Subnetzmaske',
    dnsServer: 'DNS-Server',
    mac: 'Netzwerk-MAC',
    mqttRelatedConfiguration: 'MQTT',
    mqttConnectionInformation: 'MQTT-Verbindung',
    sessionConfiguration: 'Sitzung',
    serverAddress: 'Serveradresse',
    clientID: 'Client-ID',
    userName: 'Benutzername',
    userPassword: 'Passwort',
    topicPrefix: 'Topic-Präfix',
    onlineChecking: 'Online-Prüfung',
    onlineCheckingTimeout: 'Zeitüberschreitung',
    cleanSession: 'Saubere Sitzung',
    clientIdSuffix: 'Client-ID-Suffix',
    willTopic: 'Will-Topic',
    enterpriseWechat:'Enterprise WeChat Modus ohne Wirkung',
    faceRelatedConfiguration: 'Gesichtskonfiguration',
    functionalInformation: 'Funktion',
    prompt: 'Hinweis',
    faceSimilarityThreshold: 'Ähnlichkeitsschwelle',
    livenessDetectionFunction: 'Lebenderkennung',
    livenessDetectionThreshold: 'Schwelle Lebendigkeit',
    infraredImageDisplay: "Infrarotbild",
    maskRecognition: "Maskenerkennung",
    strangerVoice: "Stimme Unbekannt",
    voiceMode: "Sprachmodus",
    voiceModeDate: 'Benutzerdefinierter Gruß',
    imageSaveType: "Speichertyp",
    saveStrangerImage: "Bild von Unbekannt speichern",
    fullView: "Panorama",
    face: "Gesicht",
    broadcastPleaseRegisterFirst: 'Spiele "Bitte zuerst registrieren"',
    broadcastHelloStranger: 'Spiele "Unbekannt"',
    broadcastName: 'Namen abspielen',
    broadcastGreeting: 'Benutzerdefinierten Gruß abspielen',
    greeting: 'Gruß',
    broadcastWelcome: '"Willkommen" abspielen',
    recognitionSwitch: 'Erneute Erkennung Schalter',
    systemRelatedConfiguration: 'System',
    functionSwitch: 'Funktionsschalter',
    cardSwipingSwitch: 'Karte',
    passwordSwitch: 'Passwort',
    strangerImage: 'Bild Unbekannter',
    cloudCertificateSwitch: 'Cloud-Zertifikat',
    physicalCardNumber: 'Physische Kartennr.',
    cloudCertificateAcquisition: 'Cloud-Zertifikat Bezug',
    heartbeatConfig: 'Heartbeat',
    heartbeatSwitch: 'Heartbeat Schalter',
    heartRateInterval: 'Intervall',
    heartbeatTopic: 'Heartbeat-Topic',
    heartbeatContent: 'Heartbeat-Inhalt',
    basicInformation: 'Basisinfo',
    deviceMac: 'MAC-Adresse',
    uuid: 'UUID',
    sn: 'SN',
    model: 'Modell',
    version: "Version",
    appVersion: "Firmware-Version",
    releaseTime: "Aktualisierungszeit",
    totaldisk: 'Gesamtbereich',
    freedisk: 'Verbleibender Platz',
    passageConfiguration: 'Passage',
    functionConfiguration: 'Funktionen',
    numberOfPassageRecords: 'Max. Durchgangsaufzeichnungen',
    durationOfRelayOpening: 'Relais-Öffnungsdauer',
    alarmSwitch: 'Alarm',
    fireAlarmSwitch: 'Brandalarm',
    fireAlarmStatus: 'Brandstatus',
    normal: 'Normal',
    warning: 'Warnung',
    tamperSwitch: 'Sabotageschutz',
    uploadToCloudSwitch: 'Gesicht-Upload-Schalter',
    clockConfiguration: 'Uhr',
    timeSynchronizationSwitch: 'Zeitsynchronisation',
    timeSynchronizationServerIP: 'Zeitserver-IP',
    timedSynchronizationTime: 'Synchronisationszeit',
    timeZone: 'Zeitzone',
    setDeviceTime: 'Gerätezeit setzen',
    restartAfterSetting: 'Gerät startet neu',
    cloudCertificateActivation: 'Cloud-Zertifikat Aktivierung',
    activationKey: 'Aktivierungsschlüssel',
    cloudTips1: 'Schlüssel ohne Leerzeichen eingeben',
    cloudTips2: 'Nach Aktivierung verbindet sich das Gerät mit dem Cloud-Service',
    confirmActivation: 'Aktivierung bestätigen',
    activationInProgress: 'Aktivierung läuft...',
    activationFailed: 'Aktivierung fehlgeschlagen',
    activationSuccessful: 'Aktivierung erfolgreich',
    passwordModification: 'Passwort ändern',
    password: 'Passwort',
    oldPassword: 'Altes Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    passwordRule: 'Passwortempfehlung',
    passwordLength: 'Länge ≥6',
    cannotBeTheSame: 'Alle Zeichen dürfen nicht gleich sein',
    cannotOrder: 'Keine 3+ aufeinanderfolgende Zahlen/Buchstaben',
    cannotWeakPassword: 'Kein schwaches Passwort',
    submit: 'Senden',
    saveConfig: 'Einstellungen speichern',
    msg_please_enter: 'Bitte eingeben',
    msg_inputPassword: 'Bitte Passwort eingeben',
    msg_oldPasswordError: 'Altes Passwort falsch',
    msg_password_mismatch: 'Passwörter stimmen nicht überein',
    msg_password_min_length: 'Mindestens 6 Zeichen',
    msg_is_weak_password: 'Schwaches Passwort, bitte ändern',
    msg_pswChangeSuccessAndLogin: 'Passwort geändert, bitte neu anmelden',
    msg_pswChangeSuccess: 'Passwort geändert',
    msg_pswChangeFail: 'Passwortänderung fehlgeschlagen',
    msg_saveSuccess: 'Erfolgreich gespeichert',
    msg_saveFail: 'Speichern fehlgeschlagen',
    msg_formFilled: 'Bitte Formular prüfen',
    msg_number_0_23: 'Nur 0 bis 23',
    msg_number_0_24: 'Nur 0 bis 24',
    msg_noChange: 'Keine Konfigurationsänderungen zu speichern',
    resourceConfiguration: 'Ressourcenkonfiguration',
    backgroundImage: 'Hintergrundbild',
    selectImage: 'Bild auswählen',
    uploadBackground: 'Hintergrund hochladen',
    uploading: 'Lädt hoch...',
    backgroundUploadTip: 'Bitte laden Sie ein PNG-Bild mit einer Auflösung von {n} Pixeln hoch. Das Bild wird in Base64-Format konvertiert und auf das Gerät hochgeladen',
    backgroundResolutionMismatch: 'Die Bildauflösung muss {n} sein',
    backgroundRequired: 'Bitte ein Hintergrundbild wählen',
    backgroundImageOnlyPNG: 'Nur PNG-Bilder',
    backgroundSizeLimit: 'Bild darf 5MB nicht überschreiten',
    backgroundParseFailed: 'Bild konnte nicht gelesen werden',
    backgroundImageSelected: 'Bild ausgewählt',
    backgroundSuccess: 'Hintergrund hochgeladen',
    backgroundFailed: 'Upload fehlgeschlagen',
    scanSettings: 'Scan-Einstellungen',
    scanSwitch: 'Scan-Schalter',
    scanInterval: 'Scan-Intervall',
  },
  person: {
    idCard: 'Ausweisnummer',
    userType: 'Personentyp',
    administrator: 'Administrator',
    userId: 'ID',
    user: 'Benutzer',
    voucher: 'Nachweis',
    permission: 'Berechtigung',
    addUser: 'Person hinzufügen',
    name: 'Name',
    editUser: 'Person bearbeiten',
    placeholderUserId: 'Benutzer-ID eingeben',
    placeholderName: 'Name eingeben',
    userNotExist: 'Person existiert nicht',
    oneClickClear: 'Alles löschen',
    clearTips: 'Dies löscht alle Daten, fortfahren?',
    clearSuccess: 'Löschen erfolgreich',
    clearFailed: 'Löschen fehlgeschlagen',
  },
  voucher: {
    password: 'Passwort',
    card: 'Karte',
    face: 'Gesicht',
    finger: 'Fingerabdruck',
    code: 'Code',
    codeType: 'Codetyp',
    passthroughCode: 'Durchgangscode',
    staticCode: 'Statischer Code',
    dynamicCode: 'Dynamischer Code',
    placeholderCode: 'Bitte Codezertifikat eingeben',
    placeholderPwd: 'Passwortnachweis eingeben',
    placeholderCard: 'Kartennachweis eingeben',
    validPassword: 'Bitte 6 Ziffern eingeben',
    validCard: 'Bitte 8 Ziffern oder Buchstaben eingeben',
    photoRegistration: 'Foto-Registrierung',
    featureValueRegistration: 'Merkmals-Registrierung',
    fingerRegistration: 'Fingerabdruck-Registrierung',
    fingerFeatureRegistration: 'Registrierung über Merkmalswert',
    fingerInput: 'Bitte legen Sie den Finger auf den Fingerabdruckscanner',
    fingerRemainingTime: 'Verbleibende Zeit',
    fingerInputting: 'Wird erfasst...',
    startFingerInput: 'Fingerabdruck erfassen',
    fingerInputTips: 'Bitte Fingerabdruck-Merkmalswert eingeben',
    fingerWaitInput: 'Warten auf Erfassung',
    fingerInputNow: 'Fingerabdruck wird erfasst...',
    fingerInputSuccess: 'Erfassung erfolgreich',
    fingerInputFailed: 'Start der Fingerabdruckerfassung fehlgeschlagen',
    fingerReTry: 'Fingerabdruckerfassung fehlgeschlagen, bitte erneut versuchen',
    fingerFilled: 'Erfassung erfolgreich, Merkmalswert wurde automatisch eingetragen',
    fingerFailed: 'Fingerabdruckerfassung fehlgeschlagen',
    fingerTimeout: 'Zeitüberschreitung',
    fingerInputTimeout: 'Zeitüberschreitung bei der Fingerabdruckerfassung, bitte erneut versuchen',
    fingerError: 'Erfassung fehlgeschlagen',
    fingerInputError: 'Fingerabdruckerfassung fehlgeschlagen, bitte erneut versuchen',
    fingerInputed: 'Fingerabdruck bereits erfasst',
    fingerReInput: 'Fingerabdruck erneut erfassen',
  },
  permission: {
    deletePermission: 'Berechtigung löschen',
    addPermission: 'Berechtigung hinzufügen',
    permissionId: 'Berechtigungs-ID',
    userId: 'Benutzer-ID',
    timeRange: 'Zeitraum',
    extra: 'Extra',
    effectiveType: 'Gültigkeitstyp',
    effectiveTime: 'Gültige Zeit',
    effectiveWeek: 'Gültige Woche',
    timePeriod: 'Zeitabschnitt',
    addTimePeriod: 'Zeitabschnitt hinzufügen',
    modify_previous_time: 'Vorherigen Abschnitt zuerst ändern',
    cannot_be_earlier: 'Endzeit darf nicht vor Startzeit liegen',
    times_cannot_overlap: 'Zeiten dürfen sich nicht überschneiden',
    choose_time_range: 'Zeitraum wählen',
    unlimitedMode: 'Unbegrenzt',
    usualMode: 'Normalmodus',
    dailyMode: 'Täglich',
    weeklyRepetitionMode: 'Wöchentliche Wiederholung',
    time_range: 'Zeitbereich',
  },
  common: {
    startDate: 'Startdatum',
    endDate: 'Enddatum',
    to: 'bis',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    close: 'Schließen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    batchDelete: 'Stapel löschen',
    startTime: 'Startzeit',
    endTime: 'Endzeit',
    monday: 'Montag',
    tuseday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saterday: 'Samstag',
    sunday: 'Sonntag',
    placeholder: 'Bitte eingeben',
    placeholderSelect: 'Bitte wählen',
    closeTips: 'Schließen bestätigen?',
    deleteTips: 'Löschen bestätigen?',
    deleteSuccess: 'Erfolgreich gelöscht',
    addSuccess: 'Erfolgreich hinzugefügt',
    editSuccess: 'Erfolgreich bearbeitet',
    saveSuccess: 'Erfolgreich gespeichert',
    tips: 'Hinweis',
    operation: 'Operation',
    query: 'Abfrage',
    reset: 'Reset',
    noData: 'Keine Daten',
    export: 'Exportieren',
    success: 'Erfolg',
    failure: 'Fehler',
    incorrectFormat: 'Falsches Format',
    integerFormat: 'Ganzzahl ≥0 erforderlich',
    positiveIntegerFormat: 'Ganzzahl >0 erforderlich',
    noDataSaved: 'Keine Daten zu speichern',
    chinese: 'Chinesisch',
    english: 'Englisch',
    spanish: 'Spanisch',
    french: 'Französisch',
    german: 'Deutsch',
    russian: 'Russisch',
    arabic: 'Arabisch',
    portuguese: 'Portugiesisch',
    korean: 'Koreanisch',
    detail: 'Details',
    clearTips: 'Wirklich leeren?​',
    clearSuccess: 'Erfolgreich gelöscht',
  },
  log: {
    accessMethod: 'Zugriffsmethode',
    passingTime: 'Durchgangszeit',
    accessPass: 'Zugangsnachweis',
    accessResult: 'Ergebnis',
    accessPhoto: 'Foto',
    viewPhotos: 'Fotos ansehen'
  },
  error: {
    networkError: 'Netzwerkfehler, Verbindung prüfen',
    timeout: 'Zeitüberschreitung, bitte erneut versuchen',
    serverError: 'Serverfehler, später erneut versuchen',
    notFound: 'Ressource nicht gefunden',
    unauthorized: 'Nicht autorisiert, bitte neu anmelden',
    noResponse: 'Keine Serverantwort, Netzwerk prüfen',
    unknownError: 'Anfrage fehlgeschlagen, Code:',
    requestFailed: 'Anfrage fehlgeschlagen'
  },
  security: {
    keyId: 'Schlüssel-ID',
    keyType: 'Schlüsseltyp',
    keyEncoding: 'Schlüsselkodierung',
    keyValue: 'Schlüsselwert',
    startTime: 'Startzeit',
    expirationTime: 'Ablaufzeit',
    newKey: 'Neuer Schlüssel',
    clearKey: 'Schlüssel löschen',
    validTime: 'Gültigkeitsdauer',
  }
}


